/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  ScheduleDraftPreviewRequest,
  ScheduleDraftSaveResponse,
  ScheduleDraftState,
  ScheduleDraftUserDto,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const scheduleDraftsPreviewPostV2 = (
  scheduleDraftPreviewRequest: BodyType<ScheduleDraftPreviewRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ScheduleDraftState>(
    {
      url: `/apix/v2/ScheduleDrafts/preview`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: scheduleDraftPreviewRequest,
      signal,
    },
    options,
  );
};

export const getScheduleDraftsPreviewPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsPreviewPostV2>>,
    TError,
    { data: BodyType<ScheduleDraftPreviewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleDraftsPreviewPostV2>>,
  TError,
  { data: BodyType<ScheduleDraftPreviewRequest> },
  TContext
> => {
  const mutationKey = ["scheduleDraftsPreviewPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleDraftsPreviewPostV2>>,
    { data: BodyType<ScheduleDraftPreviewRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return scheduleDraftsPreviewPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleDraftsPreviewPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleDraftsPreviewPostV2>>
>;
export type ScheduleDraftsPreviewPostV2MutationBody =
  BodyType<ScheduleDraftPreviewRequest>;
export type ScheduleDraftsPreviewPostV2MutationError = ErrorType<unknown>;

export const useScheduleDraftsPreviewPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsPreviewPostV2>>,
    TError,
    { data: BodyType<ScheduleDraftPreviewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduleDraftsPreviewPostV2>>,
  TError,
  { data: BodyType<ScheduleDraftPreviewRequest> },
  TContext
> => {
  const mutationOptions =
    getScheduleDraftsPreviewPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const scheduleDraftsPostV2 = (
  scheduleDraftState: BodyType<ScheduleDraftState>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ScheduleDraftSaveResponse>(
    {
      url: `/apix/v2/ScheduleDrafts`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: scheduleDraftState,
      signal,
    },
    options,
  );
};

export const getScheduleDraftsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsPostV2>>,
    TError,
    { data: BodyType<ScheduleDraftState> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleDraftsPostV2>>,
  TError,
  { data: BodyType<ScheduleDraftState> },
  TContext
> => {
  const mutationKey = ["scheduleDraftsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleDraftsPostV2>>,
    { data: BodyType<ScheduleDraftState> }
  > = (props) => {
    const { data } = props ?? {};

    return scheduleDraftsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleDraftsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleDraftsPostV2>>
>;
export type ScheduleDraftsPostV2MutationBody = BodyType<ScheduleDraftState>;
export type ScheduleDraftsPostV2MutationError = ErrorType<unknown>;

export const useScheduleDraftsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsPostV2>>,
    TError,
    { data: BodyType<ScheduleDraftState> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduleDraftsPostV2>>,
  TError,
  { data: BodyType<ScheduleDraftState> },
  TContext
> => {
  const mutationOptions = getScheduleDraftsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const scheduleDraftsStartByJobIdPostV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/ScheduleDrafts/${jobId}/start`, method: "POST", signal },
    options,
  );
};

export const getScheduleDraftsStartByJobIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsStartByJobIdPostV2>>,
    TError,
    { jobId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleDraftsStartByJobIdPostV2>>,
  TError,
  { jobId: number },
  TContext
> => {
  const mutationKey = ["scheduleDraftsStartByJobIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleDraftsStartByJobIdPostV2>>,
    { jobId: number }
  > = (props) => {
    const { jobId } = props ?? {};

    return scheduleDraftsStartByJobIdPostV2(jobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleDraftsStartByJobIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleDraftsStartByJobIdPostV2>>
>;

export type ScheduleDraftsStartByJobIdPostV2MutationError = ErrorType<unknown>;

export const useScheduleDraftsStartByJobIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsStartByJobIdPostV2>>,
    TError,
    { jobId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduleDraftsStartByJobIdPostV2>>,
  TError,
  { jobId: number },
  TContext
> => {
  const mutationOptions =
    getScheduleDraftsStartByJobIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const scheduleDraftsEndByJobIdPostV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/ScheduleDrafts/${jobId}/end`, method: "POST", signal },
    options,
  );
};

export const getScheduleDraftsEndByJobIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsEndByJobIdPostV2>>,
    TError,
    { jobId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleDraftsEndByJobIdPostV2>>,
  TError,
  { jobId: number },
  TContext
> => {
  const mutationKey = ["scheduleDraftsEndByJobIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleDraftsEndByJobIdPostV2>>,
    { jobId: number }
  > = (props) => {
    const { jobId } = props ?? {};

    return scheduleDraftsEndByJobIdPostV2(jobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleDraftsEndByJobIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleDraftsEndByJobIdPostV2>>
>;

export type ScheduleDraftsEndByJobIdPostV2MutationError = ErrorType<unknown>;

export const useScheduleDraftsEndByJobIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleDraftsEndByJobIdPostV2>>,
    TError,
    { jobId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduleDraftsEndByJobIdPostV2>>,
  TError,
  { jobId: number },
  TContext
> => {
  const mutationOptions =
    getScheduleDraftsEndByJobIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const scheduleDraftsUserByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ScheduleDraftUserDto>(
    { url: `/apix/v2/ScheduleDrafts/${jobId}/user`, method: "GET", signal },
    options,
  );
};

export const getScheduleDraftsUserByJobIdGetV2QueryKey = (jobId?: number) => {
  return [`/apix/v2/ScheduleDrafts/${jobId}/user`] as const;
};

export const getScheduleDraftsUserByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof scheduleDraftsUserByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof scheduleDraftsUserByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getScheduleDraftsUserByJobIdGetV2QueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof scheduleDraftsUserByJobIdGetV2>>
  > = ({ signal }) =>
    scheduleDraftsUserByJobIdGetV2(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof scheduleDraftsUserByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScheduleDraftsUserByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof scheduleDraftsUserByJobIdGetV2>>
>;
export type ScheduleDraftsUserByJobIdGetV2QueryError = ErrorType<unknown>;

export function useScheduleDraftsUserByJobIdGetV2<
  TData = Awaited<ReturnType<typeof scheduleDraftsUserByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof scheduleDraftsUserByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScheduleDraftsUserByJobIdGetV2QueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
